import React from 'react';
import { useRBAC } from '~/hooks/useRBAC';

export type SearchCategory =
  | 'All'
  | 'Documents'
  | 'Funds'
  | 'Portfolios'
  | 'Widgets';

interface GlobalSearchTabsProps {
  activeCategory: SearchCategory;
  onCategoryChange: (category: SearchCategory) => void;
}

export const GlobalSearchTabs: React.FC<GlobalSearchTabsProps> = ({
  activeCategory,
  onCategoryChange,
}) => {
  const { hasAccess } = useRBAC();
  const categories: SearchCategory[] = ['All'];

  if (hasAccess('fund')) {
    categories.push('Funds');
  }

  if (hasAccess('document')) {
    categories.push('Documents');
  }

  if (hasAccess('portfolio')) {
    categories.push('Portfolios');
  }

  if (hasAccess('widget')) {
    categories.push('Widgets');
  }

  const getCategoryIcon = (category: SearchCategory): string => {
    switch (category) {
      case 'All':
        return 'pi pi-list';
      case 'Funds':
        return 'pi pi-money-bill';
      case 'Documents':
        return 'pi pi-file';
      case 'Portfolios':
        return 'pi pi-building';
      case 'Widgets':
        return 'pi pi-chart-bar';
      default:
        return '';
    }
  };

  return (
    <div
      className="w-full"
      style={{
        borderBottom: 'none',
        // backgroundColor: 'var(--surface-card)',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        overflow: 'hidden',
        marginBottom: '2px',
      }}
    >
      <div className="flex">
        {categories.map((category) => (
          <div
            key={category}
            className="flex align-items-center justify-content-center"
            style={{
              position: 'relative',
              cursor: 'pointer',
              padding: '0.75rem 1.25rem',
              borderTop: '1px solid transparent',
              borderLeft:
                activeCategory === category
                  ? '1px solid var(--bq-color-info, #3B82F6)'
                  : '1px solid var(--bq-color-gray-border, #dee2e6)',
              borderRight:
                activeCategory === category
                  ? '1px solid var(--bq-color-info, #3B82F6)'
                  : '1px solid var(--bq-color-gray-border, #dee2e6)',
              borderBottom:
                activeCategory === category
                  ? '1px solid var(--bq-color-info, #3B82F6)'
                  : '1px solid var(--bq-color-gray-border, #dee2e6)',
              borderTopLeftRadius: '6px',
              borderTopRightRadius: '6px',
              backgroundColor:
                activeCategory === category
                  ? 'var(--bq-color-info, #3B82F6)'
                  : 'var(--bq-color-gray-light2, #f1f5f9)',
              color:
                activeCategory === category
                  ? 'var(--bq-color-info-text, #ffffff)'
                  : 'var(--bq-color-black, #000000)',
              fontWeight: activeCategory === category ? '600' : '400',
              minWidth: '100px',
              textAlign: 'center',
              marginRight: '2px',
              marginBottom: '2px',
              zIndex: activeCategory === category ? '1' : '0',
              outline: 'none',
            }}
            onClick={() => onCategoryChange(category)}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onCategoryChange(category);
              }
            }}
          >
            <i
              className={`${getCategoryIcon(category)} mr-2`}
              style={{
                fontSize: '0.9rem',
                opacity: activeCategory === category ? 1 : 0.7,
              }}
            />
            {category}
          </div>
        ))}
        <div
          style={{
            flexGrow: 1,
            borderBottom: 'none',
          }}
        />
      </div>
    </div>
  );
};
